import { sport, oddsTypeUOF } from 'constants/enum';

const grupoacrismatic = {
  [sport.soccer]: {
    'pre': [
      oddsTypeUOF[sport.soccer].pre.three_way,
      oddsTypeUOF[sport.soccer].pre.two_way,
      oddsTypeUOF[sport.soccer].pre.total,
      oddsTypeUOF[sport.soccer].pre.spread,
      oddsTypeUOF[sport.soccer].pre.handicap,
    ],
    'live': [
      oddsTypeUOF[sport.soccer].pre.correct_score,
      oddsTypeUOF[sport.soccer].live.three_way_live,
      oddsTypeUOF[sport.soccer].live.restofthematch,
      oddsTypeUOF[sport.soccer].live.total,
      oddsTypeUOF[sport.soccer].live.total_first_half,
      oddsTypeUOF[sport.soccer].live.handicap,
      oddsTypeUOF[sport.soccer].live.nextgoal,
      oddsTypeUOF[sport.soccer].live.ht_who_wins_the_rest,
      oddsTypeUOF[sport.soccer].live.halftime_1x2,
      oddsTypeUOF[sport.soccer].live.asian_handicap,
      oddsTypeUOF[sport.soccer].live.asian_handicap_first_half,
      oddsTypeUOF[sport.soccer].live.draw_no_bet,
      oddsTypeUOF[sport.soccer].live.double_chance,
      oddsTypeUOF[sport.soccer].live.three_way_only_ot,
      oddsTypeUOF[sport.soccer].live.rest_of_match_only_ot,
      oddsTypeUOF[sport.soccer].live.total_live_only_ot,
      oddsTypeUOF[sport.soccer].live.next_goal_only_ot,
      oddsTypeUOF[sport.soccer].live.win_penalties,
    ],
  },
  [sport.basketball]: {
    'pre': [
      oddsTypeUOF[sport.basketball].pre.three_way,
      oddsTypeUOF[sport.basketball].pre.two_way,
      oddsTypeUOF[sport.basketball].pre.total,
      oddsTypeUOF[sport.basketball].pre.spread,
      oddsTypeUOF[sport.basketball].pre.handicap,
    ],
    'live': [
      oddsTypeUOF[sport.basketball].live.two_way_live_ot,
      oddsTypeUOF[sport.basketball].live.asian_handicap_ot,
      oddsTypeUOF[sport.basketball].live.total_incl_ot,
      oddsTypeUOF[sport.basketball].live.total_current_round,
      oddsTypeUOF[sport.basketball].live.win_current_period,
      oddsTypeUOF[sport.basketball].live.handicap_current_period,
      oddsTypeUOF[sport.basketball].live.total_first_half,
      oddsTypeUOF[sport.basketball].live.two_way_fist_half,
      oddsTypeUOF[sport.basketball].live.asian_handicap_first_half,
      oddsTypeUOF[sport.basketball].live.race_to_points,
      oddsTypeUOF[sport.basketball].live.who_scores_point,
    ],
  },
  [sport.ice_hockey]: {
    'pre': [
      oddsTypeUOF[sport.ice_hockey].pre.three_way,
      oddsTypeUOF[sport.ice_hockey].pre.two_way,
      oddsTypeUOF[sport.ice_hockey].pre.total,
      oddsTypeUOF[sport.ice_hockey].pre.spread,
      oddsTypeUOF[sport.ice_hockey].pre.handicap,
    ],
    'live': [
      oddsTypeUOF[sport.ice_hockey].live.three_way_live,
      oddsTypeUOF[sport.ice_hockey].live.nextgoal,
      oddsTypeUOF[sport.ice_hockey].live.total,
      oddsTypeUOF[sport.ice_hockey].live.win_current_period,
      oddsTypeUOF[sport.ice_hockey].live.total_current_round,
      oddsTypeUOF[sport.ice_hockey].live.two_way_live_ot,
      oddsTypeUOF[sport.ice_hockey].live.handicap,
      oddsTypeUOF[sport.ice_hockey].live.restofthematch,
      oddsTypeUOF[sport.ice_hockey].live.rest_of_period,
      oddsTypeUOF[sport.ice_hockey].live.draw_no_bet,
      oddsTypeUOF[sport.ice_hockey].live.double_chance,
    ],
  },
  [sport.tennis]: {
    'pre': [
      oddsTypeUOF[sport.tennis].pre.three_way,
      oddsTypeUOF[sport.tennis].pre.two_way,
      oddsTypeUOF[sport.tennis].pre.handicap,
      oddsTypeUOF[sport.tennis].pre.correct_score,
    ],
    'live': [
      oddsTypeUOF[sport.tennis].live.win_tennis_match,
      oddsTypeUOF[sport.tennis].live.win_tennis_set,
      oddsTypeUOF[sport.tennis].live.win_tennis_game,
      oddsTypeUOF[sport.tennis].live.total_current_round,
      oddsTypeUOF[sport.tennis].live.total_games_in_match,
      oddsTypeUOF[sport.tennis].live.tennis_number_of_sets,
      oddsTypeUOF[sport.tennis].live.tennis_results,
      oddsTypeUOF[sport.tennis].live.win_games_of_set,
      oddsTypeUOF[sport.tennis].live.set_handicap,
    ],
  },
  [sport.handball]: {
    'pre': [
      oddsTypeUOF[sport.handball].pre.three_way,
      oddsTypeUOF[sport.handball].pre.two_way,
      oddsTypeUOF[sport.handball].pre.total,
      oddsTypeUOF[sport.handball].pre.spread,
      oddsTypeUOF[sport.handball].pre.handicap,
    ],
    'live': [
      oddsTypeUOF[sport.handball].live.three_way_live,
      oddsTypeUOF[sport.handball].live.handicap,
      oddsTypeUOF[sport.handball].live.total,
      oddsTypeUOF[sport.handball].live.total_first_half,
      oddsTypeUOF[sport.handball].live.handicap_first_half,
      oddsTypeUOF[sport.handball].live.halftime_1x2,
      oddsTypeUOF[sport.handball].live.asian_handicap,
      oddsTypeUOF[sport.handball].live.asian_handicap_first_half,
      oddsTypeUOF[sport.handball].live.race_to_points,
      oddsTypeUOF[sport.handball].live.nextgoal,
    ],
  },
  [sport.volleyball]: {
    'pre': [
      oddsTypeUOF[sport.volleyball].pre.three_way,
      oddsTypeUOF[sport.volleyball].pre.two_way,
      oddsTypeUOF[sport.volleyball].pre.total,
      oddsTypeUOF[sport.volleyball].pre.spread,
      oddsTypeUOF[sport.volleyball].pre.handicap,
      oddsTypeUOF[sport.volleyball].pre.correct_score,
    ],
    'live': [
      oddsTypeUOF[sport.volleyball].live.two_way_live,
      oddsTypeUOF[sport.volleyball].live.win_current_period,
      oddsTypeUOF[sport.volleyball].live.handicap_current_period,
      oddsTypeUOF[sport.volleyball].live.total_current_round,
      oddsTypeUOF[sport.volleyball].live.total,
      oddsTypeUOF[sport.volleyball].live.tennis_results,
      oddsTypeUOF[sport.volleyball].live.asian_handicap,
      oddsTypeUOF[sport.volleyball].live.race_to_points,
      oddsTypeUOF[sport.volleyball].live.who_scores_point,
    ],
  },
  [sport.futsal]: {
    'pre': [
      oddsTypeUOF[sport.futsal].pre.three_way,
      oddsTypeUOF[sport.futsal].pre.two_way,
      oddsTypeUOF[sport.futsal].pre.total,
      oddsTypeUOF[sport.futsal].pre.spread,
      oddsTypeUOF[sport.futsal].pre.handicap,
      oddsTypeUOF[sport.futsal].pre.correct_score,
    ],
    'live': [
      oddsTypeUOF[sport.futsal].live.three_way_live,
      oddsTypeUOF[sport.futsal].live.nextgoal,
      oddsTypeUOF[sport.futsal].live.asian_handicap,
      oddsTypeUOF[sport.futsal].live.total,
      oddsTypeUOF[sport.futsal].live.total_first_half,
      oddsTypeUOF[sport.futsal].live.restofthematch,
      oddsTypeUOF[sport.futsal].live.halftime_1x2,
      oddsTypeUOF[sport.futsal].live.asian_handicap_first_half,
      oddsTypeUOF[sport.futsal].live.ht_who_wins_the_rest,
      oddsTypeUOF[sport.futsal].live.draw_no_bet,
      oddsTypeUOF[sport.futsal].live.three_way_only_ot,
      oddsTypeUOF[sport.futsal].live.next_goal_only_ot,
      oddsTypeUOF[sport.futsal].live.total_live_only_ot,
      oddsTypeUOF[sport.futsal].live.rest_of_match_only_ot,
      oddsTypeUOF[sport.futsal].live.win_penalties,
    ],
  },
};

export default grupoacrismatic;
